import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { trackPageView } from "../util/analytics";
import Header from "../layouts/Header/Header3.tsx";
import Footer2 from "../layouts/Footer/Footer2.tsx";
import AboutUsPage2 from "../pages/AboutUsPage/AboutUsPage2.tsx";
import TeamPage from "../pages/AboutUsPage/TeamPage.tsx";
import HomePage from "../pages/HomePage/HomePage.tsx";
import ContactUsPage2 from "../pages/ContactUsPage/ContactUsPage2.tsx";
import RentPage from "../pages/RentPages/RentPage.tsx";
import LandlordsPage from "../pages/LandlordsPage/LandlordsPage2.tsx";
// import QualificationsPage from "../pages/QualificationsPage/QualificationsPage.tsx";
import {
  PoliciesCookies,
  PoliciesPrivacy,
  PoliciesTerms,
} from "../pages/Policies/Policies.tsx";
import CareersPage2 from "../pages/CareersPage/CareersPage2.tsx";
import BannerCookie from "../layouts/BannerCookie/BannerCookie.tsx";
import PropertiesPage from "../pages/RentPages/PropertiesPage.tsx";
import StampDutyPage2 from "../pages/LandlordsPage/StampDutyPage/StampDutyPage2.tsx";
import YieldPage2 from "../pages/LandlordsPage/YieldPage/YieldPage2.tsx";
import RentEstimatePage2 from "../pages/LandlordsPage/RentEstimatePage/RentEstimatePage2.tsx";
import MortgagePage2 from "../pages/LandlordsPage/MortgagePage/MortgagePage2.tsx";
import SinglePropertyPage from "../pages/RentPages/SinglePropertyPage.tsx";
import InsightsPage from "../pages/Insights/InsightsPage.tsx";
import InsightArticlePage from "../pages/Insights/InsightArticlePage.tsx";
import ConciergePage from "../pages/Concierge/ConciergePage.tsx";
import TenantGuidesPage from "../pages/Guides/TenantGuidesPage.tsx";
import TenantFeesPage from "../pages/Guides/TenantFeesPage.tsx";
import ComplaintsPage from "../pages/Guides/ComplaintsPage.tsx";
import AreaGuidesHubPage from "../pages/Guides/AreaGuidesHubPage.tsx";
import AreaGuideDetailPage from "../pages/Guides/AreaGuideDetailPage.tsx";
import BuyPage from "../pages/BuyPage/BuyPage.tsx";
import PropertymarkArticlePage from "../pages/News/PropertymarkArticlePage.tsx";

function PageViewTracker(): null {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function ScrollToTop(): null {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

export default function AppRoutes(): JSX.Element {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/about-us" element={<AboutUsPage2 />} />
          <Route path="/about-us/team" element={<TeamPage />} />
          <Route path="/contact-us" element={<ContactUsPage2 />} />
          <Route path="/careers" element={<CareersPage2 />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<InsightArticlePage />} />
          <Route path="/concierge" element={<ConciergePage />} />
          {/* <Route path="/qualifications" element={<QualificationsPage />} /> */}
          <Route path="/services/rent" element={<RentPage />} />
          <Route path="/services/buy" element={<BuyPage />} />
          <Route
            path="/services/rent/properties"
            element={<PropertiesPage />}
          />
          <Route
            path="/services/rent/properties/map"
            element={<PropertiesPage />}
          />
          <Route
            path="/services/rent/properties/list"
            element={<PropertiesPage />}
          />
          <Route
            path="/services/rent/properties/:id"
            element={<SinglePropertyPage />}
          />
          <Route path="/services/landlords" element={<LandlordsPage />} />
          <Route path="/guides/landlords" element={<LandlordsPage />} />
          <Route path="/guides/tenants" element={<TenantGuidesPage />} />
          <Route path="/guides/tenant-fees" element={<TenantFeesPage />} />
          <Route path="/guides/areas" element={<AreaGuidesHubPage />} />
          <Route path="/guides/areas/:slug" element={<AreaGuideDetailPage />} />
          <Route path="/policies/complaints" element={<ComplaintsPage />} />
          {/* <Route path="/services/rent/properties" element={<PropertiesPage />} /> */}
          <Route
            path="/services/stamp-duty-calculator"
            element={<StampDutyPage2 />}
          />
          <Route
            path="/services/rent-estimate"
            element={<RentEstimatePage2 />}
          />
          <Route
            path="/services/mortgage-calculator"
            element={<MortgagePage2 />}
          />
          <Route path="/services/rental-yield" element={<YieldPage2 />} />
          {/* <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/add-listings" element={<AddListingPage />} />
          <Route
            path="/dashboard/manage-listings"
            element={<ManageListingPage />}
          /> */}
          <Route
            path="/policies/terms-and-conditions"
            element={<PoliciesTerms />}
          />
          <Route
            path="/policies/privacy-policy"
            element={<PoliciesPrivacy />}
          />
          <Route
            path="/policies/cookies-policy"
            element={<PoliciesCookies />}
          />
          <Route path="/news/propertymark-one-2026" element={<PropertymarkArticlePage />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </main>
      <BannerCookie />
      <Footer2 />
    </BrowserRouter>
  );
}
